import { Icon, Text } from "@zapier/design-system";
import { Button } from "@zapier/design-system-beta";
import { useSetAtom } from "jotai";
import {
  deselectAllEdgesAtom,
  deselectAllNodesAtom,
  sidebarOpenNodeIdAtom,
} from "@zapier/canvas-state";

import { CloseButton } from "../CloseButton";

import styles from "./Sidebar.module.css";

type Props = {
  heading: string | undefined;
  children: React.ReactNode;
  onDeleteStep?: () => void;
};

export const Sidebar = ({ heading, children, onDeleteStep }: Props) => {
  const deselectNode = useSetAtom(deselectAllNodesAtom);
  const deselectAllEdges = useSetAtom(deselectAllEdgesAtom);
  const setSidebarOpenNodeId = useSetAtom(sidebarOpenNodeIdAtom);

  const onClose = () => {
    deselectNode();
    deselectAllEdges();
    setSidebarOpenNodeId("");
  };

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className={styles.toolbar} onClick={(e) => e.stopPropagation()}>
        <div className={styles.toolbarHeader}>
          {heading && <Text type="ParagraphHeader3">{heading}</Text>}
          {!heading && (
            <Text type="ParagraphHeader1">
              <span className={styles.untitledStep}>Untitled step</span>
            </Text>
          )}
          {onDeleteStep && (
            <div className={styles.deleteStepButton}>
              <Button size="small" variant="tertiary" onPress={onDeleteStep}>
                <span className={styles.iconButton}>
                  <Icon name="actionTrash" size={18} />
                  Remove
                </span>
              </Button>
            </div>
          )}
          <CloseButton onClose={onClose} />
        </div>
        <div className={styles.toolbarContent}>{children}</div>
      </div>
    </>
  );
};
